export interface DemonstrativeExportProps {
  conciliation_id?: string;
}

export const DEMONSTRATIVE_EXPORT_LABELS = {
  trigger: "Exportar Demonstrativo",
  exporting: "Enviando…",
  formatsTitle: "Formatos Disponíveis",
  excelTitle: "Planilha Excel",
  excelHint: "Demonstrativo e Saldo Parcial em abas separadas",
  pdfTitle: "Relatório PDF",
  pdfHint: "Demonstrativo e Saldo Parcial para impressão",
} as const;

export const EMAIL_PLACEHOLDER = "{email}";

export const DEMONSTRATIVE_EXPORT_MESSAGES = {
  queued: `Estamos gerando sua exportação. Ela chegará em ${EMAIL_PLACEHOLDER} e nas suas notificações.`,
  excelError: "Erro ao solicitar a planilha Excel. Tente novamente.",
  pdfError: "Erro ao solicitar o relatório PDF. Tente novamente.",
} as const;

export const DEMONSTRATIVE_EXPORT_TOAST_DURATION = 5000;

export const exportButtonClass =
  "w-full flex items-center gap-3 px-3 py-3 text-sm text-left hover:bg-[#F4C83E]/20 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150 group";

export const iconContainerClass =
  "flex items-center justify-center w-8 h-8 bg-[#F4C83E]/20 rounded-lg group-hover:bg-[#F4C83E]/30 transition-colors";
